import auth from './src/auth/auth.js'
import http from './src/http.js'

export let _Vue

const Via = {
  install: function(Vue) {
    if (this.installed && _Vue === Vue) return
    this.installed = true

    _Vue = Vue

    // ===== Prototypes
    Object.defineProperty(Vue.prototype, '$auth', {
      get: function() {
        return auth
      }
    })
    Object.defineProperty(Vue.prototype, '$http', {
      get: function() {
        return http.ajax
      }
    })
    Object.defineProperty(Vue.prototype, '$axios', {
      get: function() {
        return http.instance
      }
    })
  }
}

export default Via